import { useState } from "react";
import CryptoJS from "crypto-js";

const useEncryption = () => {
    const secretKey = process.env.REACT_APP_SECRET_KEY;

    // Function to encrypt an object
    const encrypt = (data) => {
        try {
            const stringData = JSON.stringify(data);
            const encryptedData = CryptoJS.AES.encrypt(stringData, secretKey).toString();
            return btoa(encryptedData);
        } catch (error) {
            console.error("Encryption failed:", error);
            return null;
        }
    };

    // Function to decrypt an object
    const decrypt = (encryptedData) => {
        try {
            const decoded = atob(encryptedData);
            const bytes = CryptoJS.AES.decrypt(decoded, secretKey);
            const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
            return decryptedData;
        } catch (error) {
            console.error("Decryption failed:", error);
            return null;
        }
    };

    return { encrypt, decrypt };
};

export default useEncryption;
